import { render, staticRenderFns } from "./LifeStageSummary.vue?vue&type=template&id=3134e636&scoped=true&"
import script from "./LifeStageSummary.vue?vue&type=script&lang=js&"
export * from "./LifeStageSummary.vue?vue&type=script&lang=js&"
import style0 from "./LifeStageSummary.vue?vue&type=style&index=0&id=3134e636&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3134e636",
  null
  
)

export default component.exports